import {inject, injectable} from "inversify";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";

export interface IUserRank {
	userId: number;
	displayName: string;
	points: number;
	rank: number;
}

export interface IRankingResponse {
	userRanking: IUserRank | null;
	maxRank: number | null;
}

export type TRankingResponse = IApiResponse<IRankingResponse>;

export interface IRankingApiProvider {
	dashboard: () => Promise<AxiosResponse<TRankingResponse>>;
}

@injectable()
export class RankingApiProvider implements IRankingApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	dashboard = () => this._http.get<TRankingResponse>("ranking/dashboard");
}
